export default {
    'SITE.ROOM.AVAILABLE': 'The room is available',
    'SITE.ROOM.NOT.AVAILABLE': 'Sorry the room is not available at this time',
    'SITE.ROOM.CHECK.AVAILABILITIES': 'Check other availabilities',
    'SITE.ROOM.SELECT': 'Please select a room',
    'SITE.ROOM.BOOK': 'BOOK A ROOM',
    'SITE.ROOM.CHOOSE.ROOM': 'Choose another room',
    'SITE.ROOM.LOADING.TEXT': 'We are checking room availabilities',
};
